export function emailIsValid(email: string): boolean {
    const codiceFiscaleRegex: RegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  
    return codiceFiscaleRegex.test(email.trim());
  }